import { notifyAuthChange, listenAuthChange } from '@/services/authChannel';

const store = {
    namespaced: true,
    state() {
        return {
            isOpen: false,
            isAuth: false,
            isUnauthorized: false,
            activeTab: null, // This tab is used for farmacie to select the right auth
            registerError: null,
            loginError: null,
            isRegisterConfirmOpen: false,
            isRestorePasswordOpen: false,
            isRestorePasswordConfirmOpen: false,
            isFacebookErrorLoginOpen: false,
            restoreEmail: null,
            bufferEmail: null,
            isNewPasswordOpen: false,
            newPasswordError: null,
            newPasswordConfirmed: null,
            profileToken: null,
            userData: null,
            userDataCompany: null,
            isShowLogoutNotification: false,
            isShowLoginNotification: false,
            isPersonalFormLoading: false,
            isCompanyFormLoading: false,
            personalFormErrors: null,
            companyFormErrors: null,
            modalMessageType: null,
            profileDeleteError: null
        };
    },
    getters: {
        isOpen: state => state.isOpen,
        isAuth: state => state.isAuth,
        registerError: state => state.registerError,
        registerConfirm: state => state.isRegisterConfirmOpen,
        isRestorePasswordConfirmOpen: state => state.isRestorePasswordConfirmOpen,
        getRestorePasswordOpen: state => state.isRestorePasswordOpen,
        getRestoreEmail: state => state.restoreEmail,
        getBufferEmail: state => state.bufferEmail,
        getLoginError: state => state.loginError,
        getIsNewPasswordOpen: state => state.isNewPasswordOpen,
        getNewPasswordError: state => state.newPasswordError,
        getNewPasswordConfirmed: state => state.newPasswordConfirmed,
        getProfileToken: state => state.profileToken,
        getUserData: state => state.userData,
        getUserDataCompany: state => state.userDataCompany,
        geAuthActiveTab: state => state.activeTab,
        getLogoutNotification: state => state.isShowLogoutNotification,
        getLoginNotification: state => state.isShowLoginNotification,
        getIsPersonalFormLoading: state => state.isPersonalFormLoading,
        getIsCompanyFormLoading: state => state.isCompanyFormLoading,
        getPersonalFormErrors: state => state.personalFormErrors,
        modalMessageType: state => state.modalMessageType,
        getCompanyFormErrors: state => state.companyFormErrors,
        getProfileDeleteError: state => state.profileDeleteError,
        getIsFacebookErrorLoginOpen: state => state.isFacebookErrorLoginOpen
    },
    mutations: {
        SET_IS_OPEN: (state, flag) => (state.isOpen = flag),
        SET_ACTIVE_TAB: (state, tab) => (state.activeTab = tab),
        SET_IS_AUTH: (state, flag) => (state.isAuth = flag),
        SET_REGISTER_ERROR: (state, error) => (state.registerError = error),
        SET_REGISTER_CONFIRM: (state, flag) => (state.isRegisterConfirmOpen = flag),
        SET_RESTORE_PASSWORD: (state, flag) => (state.isRestorePasswordOpen = flag),
        SET_RESTORE_PASSWORD_CONFIRM: (state, flag) => (state.isRestorePasswordConfirmOpen = flag),
        SET_RESTORE_EMAIL: (state, email) => (state.restoreEmail = email),
        SET_BUFFER_EMAIL: (state, email) => (state.bufferEmail = email),
        SET_LOGIN_ERROR: (state, error) => (state.loginError = error),
        SET_IS_NEW_PASSWORD_OPEN: (state, flag) => (state.isNewPasswordOpen = flag),
        SET_NEW_PASSWORD_ERROR: (state, error) => (state.newPasswordError = error),
        SET_NEW_PASSWORD_CONFIRMED: (state, flag) => (state.newPasswordConfirmed = flag),
        SET_PROFILE_TOKEN: (state, token) => (state.profileToken = token),
        SET_USER_DATA: (state, data) => (state.userData = data),
        SET_USER_DATA_COMPANY: (state, data) => (state.userDataCompany = data),
        SET_USER: (state, data) => (state.userData.user = data),
        SET_COMPANY: (state, data) => (state.userData.company = data),
        SET_LOGOUT_NOTIFICATION: (state, data) => (state.isShowLogoutNotification = data),
        SET_LOGIN_NOTIFICATION: (state, data) => (state.isShowLoginNotification = data),
        SET_PERSONAL_FORM_LOADING: (state, data) => (state.isPersonalFormLoading = data),
        SET_COMPANY_FORM_LOADING: (state, data) => (state.isCompanyFormLoading = data),
        SET_PERSONAL_FORM_ERRORS: (state, data) => (state.personalFormErrors = data),
        SET_COMPANY_FORM_ERRORS: (state, data) => (state.companyFormErrors = data),
        SET_PROFILE_DELETE_ERROR: (state, data) => (state.profileDeleteError = data),
        SET_MODAL_MESSAGE_TYPE: (state, data) => (state.modalMessageType = data),
        SET_IS_UNAUTHORIZED: (state, data) => (state.isUnauthorized = data),
        SET_FACEBOOK_ERROR_LOGIN_OPEN: (state, data) => (state.isFacebookErrorLoginOpen = data)
    },
    actions: {
        setActiveTab: ({ commit }, data = 'login') => commit('SET_ACTIVE_TAB', data),
        setIsOpen: ({ commit }, data) => commit('SET_IS_OPEN', data),
        setIsAuth: ({ commit }, data) => commit('SET_IS_AUTH', data),
        setIsUnauthorized: ({ commit }, data) => commit('SET_IS_UNAUTHORIZED', data),
        setShowLogoutNotification: ({ commit }, data) => commit('SET_LOGOUT_NOTIFICATION', data),
        setShowLoginNotification: ({ commit }, data) => commit('SET_LOGIN_NOTIFICATION', data),
        setBufferEmail: ({ commit }, email) => commit('SET_BUFFER_EMAIL', email),
        setModalMessageType: ({ commit }, type) => commit('SET_MODAL_MESSAGE_TYPE', type),
        setAuthentification: async function ({ commit, dispatch }, { access, refresh }) {
            if (access) {
                const expiresDate = new Date();
                expiresDate.setDate(expiresDate.getDate() + 2); // 2 дня

                this.$cookies.set('token', access, {
                    path: '/',
                    maxAge: 2 * 24 * 60 * 60,
                    expires: expiresDate,
                    sameSite: 'None',
                    secure: true
                });

                if (refresh) {
                    this.$cookies.set('refresh_token', refresh, {
                        path: '/',
                        maxAge: 7 * 24 * 60 * 60,
                        expires: new Date(Date.now() + 7 * 24 * 60 * 60 * 1000),
                        sameSite: 'None',
                        secure: true
                    });
                }
                this.$axios.setHeader('Authorization', `Bearer ${access}`);
                commit('SET_PROFILE_TOKEN', access);
                commit('SET_IS_AUTH', true);
                commit('SET_IS_UNAUTHORIZED', false);
                notifyAuthChange(true);
                await dispatch('fetchUserData');

                if (process.client) {
                    setTimeout(() => {
                        location.reload();
                    }, 200);
                }
            }
        },
        socialAuthentication: async function ({ commit, dispatch }, { access, strategy, socialUrl = 'google-auth' }) {
            // try {
            const { data } = await this.$axios({
                method: 'POST',
                url: `/users/${socialUrl}/`,
                data: {
                    access_token: access,
                    platform: strategy
                }
            });

            const newAccess = data.access_token;
            const newRefresh = data.refresh_token;

            await dispatch('setAuthentification', {
                access: newAccess,
                refresh: newRefresh
            });

            await dispatch('farmacieCart/mergeCart', null, { root: true });

            // } catch (e) {
            //     throw new Error('Something went wrong in authentification from socials')
            // }
        },
        twitterAuthentication: async function ({ commit, dispatch }, { oauth_token, oauth_verifier }) {
            const { data } = await this.$axios({
                method: 'POST',
                url: `/users/twitter-auth/auth/`,
                data: {
                    oauth_token,
                    oauth_verifier
                }
            });

            const newAccess = data.access_token;
            const newRefresh = data.refresh_token;

            await dispatch('setAuthentification', {
                access: newAccess,
                refresh: newRefresh
            });

            await dispatch('farmacieCart/mergeCart', null, { root: true });
        },
        async loginWithFacebook({ commit, dispatch }) {
            try {
                // Оборачиваем FB.login в промис
                const response = await new Promise((resolve, reject) => {
                    FB.login(
                        response => {
                            if (response.authResponse) {
                                resolve(response.authResponse);
                            } else {
                                return;
                                // reject(new Error('User cancelled login or failed.'));
                            }
                        },
                        { scope: 'email' }
                    );
                });

                const userInfo = await new Promise((resolve, reject) => {
                    FB.api('/me', { fields: 'id,name,email,picture' }, function (response) {
                        if (!response?.email) {
                            commit('SET_IS_OPEN', false);
                            commit('SET_FACEBOOK_ERROR_LOGIN_OPEN', true);
                            return false;
                        }

                        resolve(response);
                    });
                });

                const { accessToken } = response;

                await dispatch('socialAuthentication', { access: accessToken, strategy: 'facebook' });
                await dispatch('setIsOpen', false);

                commit('SET_LOGIN_NOTIFICATION', true);
                // await this.$router.push({ path: this.localePath('/') });
                setTimeout(() => {
                    commit('SET_LOGIN_NOTIFICATION', false);
                }, 3000);
            } catch (error) {
                throw error;
            }
        },

        register: async function ({ commit }, data) {
            commit('SET_REGISTER_ERROR', null);
            commit('SET_IS_UNAUTHORIZED', false);
            try {
                const { data: tokens, status } = await this.$axios({
                    method: 'POST',
                    url: `/auth/users/`,
                    data
                });

                // this.$cookies.set('token', tokens.access);
                // this.$axios.setHeader('Authorization', `Bearer ${tokens.access}`);
                // commit('SET_IS_AUTH', true);
            } catch (e) {
                console.error('Error occurred:', e);
                if (e?.response && e?.response?.data) {
                    commit('SET_REGISTER_ERROR', e.response.data);
                } else {
                    commit('SET_REGISTER_ERROR', { message: 'Unknown error occurred' });
                }
            }
        },
        confirmRegister: async function ({ commit, dispatch }, { uid, token, executeRedirect = true }) {
            commit('SET_REGISTER_ERROR', null);
            commit('SET_IS_UNAUTHORIZED', false);
            try {
                const { data: tokens, status } = await this.$axios({
                    method: 'POST',
                    url: `/auth/users/activation/`,
                    data: { uid, token }
                });

                await this.$axios({
                    method: 'GET',
                    url: `/auth/users/me/`,
                    headers: {
                        Authorization: `Bearer ${tokens.access}`
                    }
                });

                await dispatch('setAuthentification', {
                    access: tokens.access,
                    refresh: tokens.refresh
                });

                if (status === 200 && executeRedirect) {
                    await this.$router.push({ path: this.localePath('/cabinet') });
                }
            } catch (e) {
                commit('SET_REGISTER_ERROR', e.response.data);
                await this.$router.push({ path: this.localePath('/') });
                console.error(e);
            }
        },
        changePassword: async function ({ commit, getters }, data) {
            try {
                return await this.$axios({
                    method: 'POST',
                    url: `/auth/users/set_password/`,
                    data
                });
            } catch (e) {
                console.error(e);
                return e.response;
            }
        },
        resetPassword: async function ({ commit }, data) {
            commit('SET_RESTORE_EMAIL', data.email);
            try {
                await this.$axios({
                    method: 'POST',
                    url: `/auth/users/reset_password/`,
                    data
                });
            } catch (e) {
                console.error(e);
            }
        },

        resetPasswordConfirm: async function ({ commit }, data) {
            commit('SET_NEW_PASSWORD_ERROR', null);

            try {
                await this.$axios({
                    method: 'POST',
                    url: `/auth/users/reset_password_confirm/`,
                    data
                });

                commit('SET_NEW_PASSWORD_CONFIRMED', true);
                await this.$router.push({ path: this.localePath('/') });
            } catch (e) {
                commit('SET_NEW_PASSWORD_ERROR', e.response.data);
                console.error(e);
            }
        },
        fetchUserData: async function ({ commit, getters }) {
            const token = getters.getProfileToken || this.$cookies.get('token');

            const user = await this.$axios({
                method: 'GET',
                url: `/users/user-group/`,
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });

            const userGroupId = user?.data?.[0]?.group_user_type?.id;
            const userGroupIdInCookie = this.$cookies.get('user-group-id') || null;

            if (!userGroupIdInCookie && userGroupId) {
                await this.$cookies.set('user-group-id', userGroupId);
            }

            const company = user?.data[0]?.company;

            user.data[0] = {
                ...user.data[0],
                loyalty_points: Number(user?.data[0]?.loyalty_points) || 0
            };
            commit('SET_USER_DATA', user.data[0]);
            commit('SET_USER_DATA_COMPANY', company);

            // try {
            //
            // } catch (e) {
            //     console.error(e);
            //     if (e?.response?.status === 401) {
            //         this.$cookies.remove('token');
            //         this.$axios.setHeader('Authorization', null);
            //         await this.$router.push({ path: this.localePath('/') });
            //         commit('SET_IS_AUTH', false);
            //         commit('SET_USER_DATA', null);
            //         commit('SET_PROFILE_TOKEN', null);
            //         this.$cookies.remove('favorites');
            //         localStorage.removeItem('cart');
            //         localStorage.removeItem('compare');
            //         localStorage.removeItem('favorites');
            //     }
            // }
        },
        changeUserData: async function ({ commit, getters }, data) {
            const token = getters.getProfileToken || this.$cookies.get('token');
            const userId = getters.getUserData?.user?.id;
            try {
                const user = await this.$axios({
                    method: 'PATCH',
                    url: `/users/user/${userId}/`,
                    headers: {
                        Authorization: `Bearer ${token}`
                    },
                    data
                });

                commit('SET_PERSONAL_FORM_LOADING', true);
                commit('SET_USER', user.data);
                commit('SET_PERSONAL_FORM_ERRORS', null);
                setTimeout(() => {
                    commit('SET_PERSONAL_FORM_LOADING', false);
                }, 3000);
            } catch (e) {
                console.error(e);
                commit('SET_PERSONAL_FORM_ERRORS', e?.response?.data || {});
            }
        },
        changeCompanyData: async function ({ commit, getters }, data) {
            const token = getters.getProfileToken || this.$cookies.get('token');
            const companyId = getters.getUserData.id;
            try {
                const company = await this.$axios({
                    method: 'PATCH',
                    url: `/users/user-group/${companyId}/create-company/`,
                    headers: {
                        Authorization: `Bearer ${token}`
                    },
                    data
                });

                commit('SET_COMPANY_FORM_LOADING', true);
                commit('SET_COMPANY', company.data);

                setTimeout(() => {
                    commit('SET_COMPANY_FORM_LOADING', false);
                }, 3000);

                commit('SET_COMPANY_FORM_ERRORS', null);
            } catch (e) {
                commit('SET_COMPANY_FORM_ERRORS', e.response.data);
                console.error(e);
            }
        },
        login: async function ({ commit, dispatch }, data) {
            commit('SET_LOGIN_ERROR', null);
            commit('SET_IS_UNAUTHORIZED', false);

            const loginLogic = async () => {
                const res = await this.$axios({
                    method: 'POST',
                    url: `/auth/jwt/create/`,
                    data
                });

                const expiresDate = new Date();
                expiresDate.setDate(expiresDate.getDate() + 2); // сохраняем токен на 2 дня

                if (data.rememberMe) {
                    this.$cookies.set('token', res.data.access, {
                        path: '/',
                        maxAge: 2 * 24 * 60 * 60,
                        expires: expiresDate, // обязательно для persist
                        sameSite: 'None', // чтобы cookie отправлялись между доменами
                        secure: true // обязательно для sameSite: 'None'
                    });

                    this.$cookies.set('refresh_token', res.data.refresh, {
                        path: '/',
                        maxAge: 7 * 24 * 60 * 60,
                        expires: new Date(Date.now() + 7 * 24 * 60 * 60 * 1000),
                        sameSite: 'None',
                        secure: true
                    });
                    this.$axios.setHeader('Authorization', `Bearer ${res.data.access}`);
                    commit('SET_IS_AUTH', true);
                    commit('SET_IS_UNAUTHORIZED', false);
                    commit('SET_PROFILE_TOKEN', res.data.access);
                } else {
                    console.log('213');
                    await dispatch('setAuthentification', {
                        access: res.data?.access,
                        refresh: res.data?.refresh
                    });
                }

                await dispatch('fetchUserData');

                commit('SET_LOGIN_NOTIFICATION', true);
                notifyAuthChange(true);
                if (process.client) {
                    // await this.$router.push({ path: this.localePath('/') });

                    setTimeout(() => {
                        location.reload();
                    }, 200);
                }
                setTimeout(() => {
                    commit('SET_LOGIN_NOTIFICATION', false);
                }, 3000);
            };

            if (data.cancelTryCatch) {
                await loginLogic();
            } else {
                try {
                    await loginLogic();
                } catch (e) {
                    commit('SET_LOGIN_ERROR', e.response.data);
                    console.error(e);
                }
            }
        },
        resetAuthData: async function ({ commit }, data) {
            this.$cookies.remove('token');
            this.$cookies.remove('refresh_token');
            this.$axios.setHeader('Authorization', null);

            commit('SET_USER_DATA', null);
            commit('SET_PROFILE_TOKEN', null);
            commit('SET_IS_AUTH', false);
        },
        logout: async function ({ commit, dispatch, rootState }, data) {
            const haveToken = this.$cookies.get('token');

            // Apply logout request only if user have token
            if (haveToken) {
                try {
                    await this.$axios({
                        method: 'POST',
                        url: `/auth/token/logout/`
                    });
                    this.$cookies.remove('token');
                    this.$cookies.remove('refresh_token');
                    this.$axios.setHeader('Authorization', null);
                    // await this.$router.push({ path: this.localePath('/') });

                    // commit('SET_USER_DATA', null);
                    // commit('SET_PROFILE_TOKEN', null);
                    // commit('SET_IS_AUTH', false);
                    notifyAuthChange(false);
                    await dispatch('clearAllData');
                    commit('SET_IS_UNAUTHORIZED', false);
                    
                    // Проверяем настройку hide_price_for_guests и очищаем корзину при разлогинивании
                    const hidePrice = rootState?.global?.globalSettings?.hide_price_for_guests;
                    if (hidePrice) {
                        // Очищаем корзину
                        await dispatch('cart/emptyCart', null, { root: true });
                        // Обновляем localStorage
                        if (process.client) {
                            localStorage.removeItem('cart');
                        }
                    }
                    
                    // this.$cookies.remove('favorites');
                    // localStorage.removeItem('compare');
                    // localStorage.removeItem('favorites');

                    commit('SET_LOGOUT_NOTIFICATION', true);
                    setTimeout(() => {
                        commit('SET_LOGOUT_NOTIFICATION', false);
                    }, 3000);
                } catch (e) {
                    console.error(e);
                }
            }
        },
        deleteProfile: async function ({ commit, getters, dispatch }, data) {
            const { token, uid } = data;
            try {
                await this.$axios({
                    method: 'POST',
                    url: `/users/user/confirm-delete-account/`,
                    headers: {
                        Authorization: null
                    },
                    data: {
                        token,
                        uid
                    }
                });

                // commit('SET_PROFILE_DELETE_SUCCESS_MODAL', true);

                // this.$cookies.remove('token');
                // this.$cookies.remove('refresh_token');
                // this.$axios.setHeader('Authorization', null);
                notifyAuthChange(false);
                await dispatch('clearAllData');

                // await this.dispatch('logout');
            } catch (e) {
                commit('SET_PROFILE_DELETE_ERROR', true);
                // commit('SET_PROFILE_DELETE_SUCCESS_MODAL', true);
                console.error(e);
            }
        },
        clearAllData: async function ({ commit }) {
            commit('SET_USER_DATA', null);
            commit('SET_PROFILE_TOKEN', null);
            commit('SET_IS_AUTH', false);
            commit('SET_IS_UNAUTHORIZED', false);

            this.$cookies.remove('token');
            this.$cookies.remove('refresh_token');
            this.$cookies.remove('user-group-id');
            this.$cookies.remove('favorites');

            delete this.$axios.defaults.headers.common['Authorization'];

            if (process.client) {
                // localStorage.removeItem('cart');
                localStorage.removeItem('compare');
                localStorage.removeItem('favorites');

                setTimeout(() => {
                    location.reload();
                }, 200);
            }
        },
        async initializeAuthListener({ commit, dispatch }) {
            await listenAuthChange(async isAuth => {
                commit('SET_IS_AUTH', isAuth);
                if (isAuth) {
                    const token = this.$cookies.get('token');
                    this.$axios.setHeader('Authorization', `Bearer ${token}`);
                    commit('SET_PROFILE_TOKEN', token);
                    commit('SET_IS_AUTH', true);
                    commit('SET_IS_UNAUTHORIZED', false);
                    await dispatch('fetchUserData');
                } else {
                    await dispatch('clearAllData');
                }
                await dispatch('farmacieCart/fetchAllCartData', null, { root: true });
            });
        }
    }
};

export default store;
